'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_2b902d32 = {"container":"Notifications_module_container__8f7e2344","alert":"Notifications_module_alert__8f7e2344","type-success":"Notifications_module_typeSuccess__8f7e2344","type-info":"Notifications_module_typeInfo__8f7e2344","type-warning":"Notifications_module_typeWarning__8f7e2344","type-error":"Notifications_module_typeError__8f7e2344"};
require("../../../assets/cjs/components/Notifications/src/Notifications~BYhX52x9.css");

exports.default = modules_2b902d32;
//# sourceMappingURL=Notifications.module.less.js.map
